"use client";

import cookieImg from "@/assets/landingPage/cookie/cookie-img.svg";
import { useT } from "@/context/TranslationContext";
import Cookies from "js-cookie";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";

const Cookie = () => {
  const [showCookie, setShowCookie] = useState(false);
  const t = useT();

  useEffect(() => {
    const savedConsent = Cookies.get("cookieConsent");
    if (!savedConsent) {
      setShowCookie(true);
    }
  }, []);

  const handleConsent = (value) => {
    Cookies.set("cookieConsent", value, { expires: 365 });
    setShowCookie(false);
  };

  if (!showCookie) return null;

  return (
    <div className="fixed bottom-5 sm:bottom-10 rtl:right-5 ltr:left-5 sm:rtl:right-10 sm:ltr:left-10 z-[90] max-w-[270px] sm:max-w-[400px] md:max-w-[400px]">
      <div className="bg-white shadow-2xl w-full h-full rounded-[12px] p-5 xl:p-7.5 border border-[#00000017] flex flex-col items-center">
        <div className="w-[35px] h-[35px] mb-5">
          <Image
            src={cookieImg}
            alt="cookie"
            width={100}
            height={100}
            className="w-full h-auto"
          />
        </div>

        <h4 className="text-[16px] font-bold text-user-text mb-2.5 text-center">
          {t("cookie.cookieSettings")}
        </h4>

        <p className="text-[14px] font-medium text-user-paragraph text-center">
          {t("cookie.weUseCookies")}{" "}
          <Link href="/privacy-and-policy" className="text-user-primary">
            {t("cookie.learnMore")}
          </Link>
        </p>

        <div className="flex flex-col items-center gap-2.5 mt-[30px] w-full">
          <button
            className="group primary-button primary-button-md w-full"
            onClick={() => handleConsent("allowed")}
          >
            <span className="primary-button-hover-effect"></span>
            <span className="primary-button-text">{t("cookie.allow")}</span>
          </button>
          <button
            className="group primary-button primary-button-md primary-border w-full"
            onClick={() => handleConsent("declined")}
          >
            <span className="primary-button-hover-effect"></span>
            <span className="primary-button-text">{t("cookie.decline")}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Cookie;
